import { Box, Stack, TextField, Typography, styled } from 'opensolar-ui'
import { styles as standardStyles } from 'styles'

export const catalogFilterFieldStyle = {
  ...standardStyles.FILTER_FIELD_STYLE,
  width: 220,
  minWidth: 200,
  maxWidth: 280,
  margin: 0,
  flex: '0 1 220px',
  boxSizing: 'border-box' as const,
}

export const CatalogPageStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(2),
}))

export const CatalogToolbarRow = styled(Stack)(({ theme }) => ({
  width: '100%',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
}))

export const CatalogFilterFields = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(2),
  flex: '1 1 auto',
  minWidth: 0,
  '& form': {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    margin: 0,
    padding: 0,
    width: 'auto',
    flex: '0 1 auto',
  },
  '& .filter-field': {
    margin: 0,
  },
  '& .add-filter': {
    margin: 0,
  },
}))

export const CatalogActionsRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  flexShrink: 0,
  gap: theme.spacing(1),
}))

export const CatalogHeaderRoot = styled(Box)({
  width: '100%',
})

export const CatalogTitle = styled(Typography)({
  fontSize: 20,
  fontWeight: 500,
  margin: 0,
  lineHeight: 1.25,
})

export const CatalogSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
  marginBottom: 0,
}))

export const CatalogSearchField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  minWidth: 240,
}))

export const CatalogueSourceIconAnchor = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
})
